import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import { MyPublicationDetailBrandContainerProps } from "../../../../interfaces/containers";
import Detail from "../../../../pages/Profile/BrandMyPublication/Detail";
import { getArticlesFromPublication, getPublicationBrand, cleanAll as cleanAllPublication } from "../../../../actions/publication";

function mapStateToProps(state: MyPublicationDetailBrandContainerProps) {
    return{
        user: state.auth.user,
        publication: state.publication
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        getPublication: getPublicationBrand,
        getArticlesFromPublication,
        cleanAllPublication
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(Detail);
